import { FIELD_TYPES } from "../../../domain/clinicalForms";

export const optionLabel = (options, value) =>
  (options || []).find((o) => o?.value === value)?.label ?? value;

export const isEmpty = (v) =>
  v === undefined ||
  v === null ||
  v === "" ||
  (Array.isArray(v) && v.length === 0);

export const isSelected = (value, optValue) =>
  Array.isArray(value) ? value.includes(optValue) : value === optValue;

export const isOptionField = (field) =>
  field.type === FIELD_TYPES.RADIO ||
  field.type === FIELD_TYPES.CHECKBOX ||
  field.type === FIELD_TYPES.SELECT ||
  field.type === FIELD_TYPES.MULTISELECT;

export const selectedOptions = (field, value) =>
  (field.options || []).filter(
    (o) => typeof o === "object" && isSelected(value, o.value)
  );

// Groups a section's fields by leading SECTION_HEADER separators so
// each subgroup becomes its own titled block in the summary. Sections
// without headers become a single group named after the section title.
export const groupSection = (section) => {
  const fields = section.fields || [];
  const hasAnyHeader = fields.some(
    (f) => f.type === FIELD_TYPES.SECTION_HEADER
  );
  if (!hasAnyHeader) {
    return [
      {
        id: section.id,
        title: section.title,
        fields,
      },
    ];
  }

  const groups = [];
  let current = null;
  fields.forEach((f) => {
    if (f.type === FIELD_TYPES.SECTION_HEADER) {
      current = { id: f.id, title: f.label || "Group", fields: [] };
      groups.push(current);
      return;
    }
    if (!current) {
      current = { id: section.id, title: section.title, fields: [] };
      groups.push(current);
    }
    current.fields.push(f);
  });
  return groups;
};
